module.exports = __webpack_public_path__ + "img/点赞.2f09f9eb.gif";